import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

import { getLabel } from './utils';

import './form.scss';

const NumberFormatInput = React.forwardRef(({
    format, hint, label, error, required, ...inputProps
}, ref) => {
    const hasError = error && error.length > 0;
    const inputClasses = classNames({
        'ml-form-field': true,
        'error': hasError,
    });

    return (
        <div className={inputClasses}>
            <label>
                <span key="label">{ getLabel(label, inputProps.name, required) }</span>
                <NumberFormat
                    key="number-format-input"
                    ref={ref}
                    format={format}
                    {...inputProps}
                />
                { hint && <div key="hint" className="ml-form-field-helptext">{ hint }</div> }
                { hasError && <div key="error" className="ml-form-field-errortext">{ error }</div> }
            </label>
        </div>
    );
});

NumberFormatInput.propTypes = {
    required: PropTypes.bool,
    format: PropTypes.string,
    hint: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.string,
};

export default NumberFormatInput;
